const justClientMatchId = [
  'supabets', 'betonalfa', 'totolotekcashpoint', 'opapsports', 'cybet', 'opap',
  'betaland', 'betcenter', 'cashpoint', 'tipico', 'myBet', 'xtip', 'betlive', 'maxbetserbia', 'mozzartbet', 'apuestatotal', 'runbet',
];

export default justClientMatchId;
